export default {
  costDetailsList: {
    column: {
      businessCompanyCode: '业务公司',
      businessCompanyName: '业务公司名称',
      businessDepartmentCode: '业务部门',
      businessDepartmentName: '业务部门名称',
      projectCode: '项目代码',
      projectName: '项目名称',
      periodName: '账期',
      createPersonNo: '操作人',
      createPersonName: '操作人名称',
      createDateStart: '创建日期起',
      createDateEnd: '创建日期止',
      goodsType: '原料类别',
      productCode: '原料编号',
      productName: '原料名称',
      productUnit: '单位',
      periodType: '统计周期',
      settlementYear: '结算年度',
      settlementMonth: '结算月度',
      settlementDate: '期间',
      settlementDateStart: '结算日期起',
      settlementDateEnd: '结算日期止',
      openingRecipientsCount: '期初领用数量',
      openingConsumptionCount: '期初耗用数量',
      openingDiffCount: '期初差异数量',
      openingDiffAmount: '期初差异金额',
      openingCostPrice: '上月成本单价',
      currentRecipientsCount: '本期领用数量',
      currentConsumptionCount: '本期耗用数量',
      currentDiffCount: '本期差异数量',
      currentDiffAmount: '本期差异金额',
      currentCostPrice: '本期平均单价',
      endRecipientsCount: '期末领用数量',
      endConsumptionCount: '期末耗用数量',
      endDiffCount: '期末差异数量',
      endDiffAmount: '期末差异金额',
      companyCode: '公司编号',
      departmentCode: '部门编号',
      sortNo: '序号',
      outboundDate: '出库日期',
      companyName: '公司',
      createDate: '创建日期',
      remark: '备注',
      subTotal: '小计',
      redBack: '红冲退回',
    },
    message: {
      noData: '您还未选择任何数据',
      pleaseSelectOne: '请选择一条数据操作',
      topFormCheckResult: '请您将数据填写完整',
      saveSuccess: '保存成功',
      deleteSuccess: '删除成功',
      baseDataIncomplete: '请将基本数据填写完整',
      data_repeat: '已存在该数据',
      cancelled: '已取消',
      canNotChange: '该数据状态不可编辑',
      noExport: '没有数据可供导出',
      noPeriodName: '请选择账期',
    },
    search: {
      gt: '大于',
      lt: '小于',
      notEqual: '不等于',
      equal: '等于',
    },
    router: {
      export: '导出',
    },
  },
};
